import zh from "@/common/lang/zh-CN";
import en from "@/common/lang/en";
export default {
	"zh-CN":zh,
	en,
}